import { jsxs as I, jsx as i } from "react/jsx-runtime";
import r from "react";
import s, { css as d } from "styled-components";
import { a as C } from "../chunks/breakpoints.907eaecd.js";
import { a as R, h as k } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { R as O } from "../chunks/index.cff5baaf.js";
import { R as S } from "../chunks/index.b09c00db.js";
const p = s(O).withConfig({
  displayName: "Icon",
  componentId: "sc-1owb05w-0"
})([""]), z = s.div.withConfig({
  displayName: "Search",
  componentId: "sc-1owb05w-1"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;box-sizing:border-box;gap:var(--spacing-1x);height:var(--size-8x);width:100%;border-bottom:var(--default-border-width) solid var(--elements-border-color);", " &:focus-within{border-bottom:var(--default-border-width) solid var(--active-border-color);}", " ", " ", "{cursor:text;}"], ({
  value: o
}) => !o && "padding-right: var(--spacing-1_5x);", ({
  $closeHover: o
}) => !o && d(["&:hover:not(:focus-within){", " border-bottom-color:transparent;}"], R), C.md(d(["min-width:312px;"])), p), B = s.input.withConfig({
  displayName: "Input",
  componentId: "sc-1owb05w-2"
})(["height:var(--size-8x);outline:none;border:none;box-sizing:border-box;background:transparent;width:100%;", " color:var(--active-placeholder-color);&::placeholder{color:var(--text-placeholder-color);}"], k), _ = r.forwardRef(({
  id: o = "",
  name: u = "",
  inputProps: h,
  placeholder: m,
  onClick: N,
  onClose: l,
  ...f
}, b) => {
  const [a, c] = r.useState(""), e = r.useRef(), [g, t] = r.useState(!1), w = (n) => {
    const y = n.target;
    c(y.value);
  }, v = () => {
    c(""), t(!1), e.current.focus();
  }, x = () => {
    c(""), t(!1), l && l(), e.current.focus();
  };
  return /* @__PURE__ */ I(z, { value: a, $closeHover: g, ref: b, "data-rango-component": "rango-search", "data-is-rango": !0, ...f, children: [
    /* @__PURE__ */ i(B, { type: "text", placeholder: m, id: o, name: u, value: a, onInput: w, onKeyDown: (n) => {
      (n.key === "Enter" || n.key === "Escape") && e.current.blur();
    }, ref: e, ...h, "data-testid": "rango-search" }),
    a ? /* @__PURE__ */ i(S, { icon: "CloseLine", size: "lg", ariaLabel: "Botão para limpar a busca", onClick: () => x(), onMouseOver: () => t(!0), onMouseOut: () => t(!1) }) : /* @__PURE__ */ i(p, { icon: "SearchLine", onClick: v })
  ] });
});
_.displayName = "RangoSearch";
export {
  _ as RangoSearch
};
